import React, { useState } from 'react';
import { Container, Paper, Box, Typography, Chip, Grid, Stack } from '@mui/material';
    const formatCast = (c) => {
        if (c.actor && c.char) {
            return (<Stack direction="row"><Typography sx={{fontWeight: 'bold', marginRight:1}}>{c.actor}</Typography><Typography>({c.char})</Typography></Stack>)
        }
        if (c.actor) {
            return `(${c.actor})`
        } 
        if (c.char) {
            return `${c.char}`
        }
    }
const App = ({setSelectedCasts, casts, selectedCasts}) => {
  const [leftChips, setLeftChips] = useState(casts);

  const handleChipClick = (chipIndex) => {
    const chipToMove = leftChips[chipIndex];
    const newLeftChips = [...leftChips];
    newLeftChips.splice(chipIndex, 1);
    setLeftChips(newLeftChips);
    setSelectedCasts([...selectedCasts, chipToMove]);
  };

  const handleChipBackClick = (chipIndex) => {
    const chipToMove = selectedCasts[chipIndex];
    const newRightChips = [...selectedCasts];
    newRightChips.splice(chipIndex, 1);
    setSelectedCasts(newRightChips);
    setLeftChips([...leftChips, chipToMove]);
  };
  return (
    <Box sx={{marginTop:5}}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Paper elevation={3}>
            <Box p={2} sx={{minHeight:100}}>
              <Typography variant="h5">All Cast</Typography>
              {leftChips.map((chip, index) => (
                <Chip
                  key={index}
                  sx={{marginRight:2, marginBottom:2, backgroundColor: chip.isInServer ? 'rgba(152, 251, 152, 0.3)': '#E3E3E3', border: chip.isInServer ? '2px solid green': 'none'}}
                  label={formatCast(chip)}
                  onClick={() => handleChipClick(index)}
                />
              ))}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={3}>
            <Box p={2} sx={{minHeight:100}}>
              <Typography variant="h5">Selected Cast</Typography>
              {selectedCasts.map((chip, index) => (
                <Chip sx={{marginRight:2, marginBottom:2, backgroundColor: chip.isInServer ? 'rgba(152, 251, 152, 0.3)': '#E3E3E3', border: chip.isInServer ? '2px solid green': 'none'}} label={formatCast(chip)} onClick={() => handleChipBackClick(index)} />
              ))}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
              
};

export default App;

